import React from 'react';
import { withStyles } from '@material-ui/core';
import { DataGrid } from 'devextreme-react';
import styles from './VehicleDetailsDialog.styles';
import { IVehicleDetailsDialog } from './VehicleDetailsDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import DynamicDataGrid from 'components/common/DataGridDevEx/DynamicDataGrid';
import { columns } from './VehicleDetailsDialog.constants';
import CustomStore from 'devextreme/data/custom_store';
import { useRetrieveVehicleDetails } from 'api/Worksale/AutoInfoCatalogue/autoInfoCatalogue';
import { useVRContextSelector } from '../VehicleSearch/VehicleSearchContext';

const VehicleDetailsDialog = (props: IVehicleDetailsDialog) => {
  const { open, onCancel, classes, data, errorHandler } = props;
  const dataGridInnerRef = React.useRef<DataGrid>();
  const [vehicleDetails, setVehicleDetails] = React.useState<any[]>([]);
  const VehicleId = useVRContextSelector<'VehicleId'>((state) => state.VehicleId);
  const { data: vehicleDetail } = useRetrieveVehicleDetails(VehicleId, errorHandler);

  React.useEffect(
    () => {
      if (VehicleId !== -1) {
        setVehicleDetails(
          vehicleDetail?.filter((item) => {
            const val = item.Details;

            return val !== null && val !== undefined && String(val).trim() !== '' && val !== '0' && val !== 0 && val !== '.';
          }) ?? []
        );
      }
    },
    [vehicleDetail]
  );

  const dataSource = new CustomStore({
    load: () => data ? data().then((items) => items.filter((item) => item.Details && item.Details.trim() !== '' && item.Details !== '0' && item.Details !== 0 && item.Details !== '.')) : vehicleDetails
  });

  const confirmationActions = (): IActionItem[] => {
    return [
      {
        title: 'Cancel',
        isDefault: true,
        listener: () => {
          onCancel();
        }
      }
    ];
  };

  function getModalContent(): JSX.Element {

    return (
      <div className={classes.formContainer}>
        <DynamicDataGrid
          dataGridClassName={classes.grid}
          columns={columns}
          allowHeaderFilting={false}
          allowUpdating={false}
          actionButtonsVisibility={false}
          gridProps={{
            dataSource: dataSource,
            dataGridRef: dataGridInnerRef,
            sorting: { mode: 'single' },
            disableDrillDown: true,
            disableEditing: true,
            disableDelete: true,
          }}
        />
      </div>
    );
  }

  return (
    <>
      <FormViewModal
        open={open}
        dialogStyles={{
          width: '600px',
          minHeight: 600,
          maxHeight: 600,
          height: '100%'
        }}
        dialogClassName={classes.parentContainer}
        loading={false}
        title={'Vehicle Details'}
        dialogActionsButtons={true}
        dialogActionsShadow={false}
        modalContent={getModalContent()}
        actions={confirmationActions()}
      />
    </>
  );
};

export default withStyles(styles, { index: 1 })(VehicleDetailsDialog);
